/**
 * Facebook Conversions API Tracking Service
 * Sends events to backend which forwards to Facebook
 */

const API = process.env.REACT_APP_BACKEND_URL;

// Get Facebook cookies
const getFacebookCookies = () => {
  const cookies = document.cookie.split(';').reduce((acc, cookie) => {
    const [key, value] = cookie.trim().split('=');
    acc[key] = value;
    return acc;
  }, {});
  
  return {
    fbc: cookies._fbc || null,
    fbp: cookies._fbp || null,
  };
};

// Generate unique event ID for deduplication
const generateEventId = () => {
  return `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * Send tracking event to Facebook via backend
 */
const trackEvent = async (eventName, additionalData = {}) => {
  try {
    const { fbc, fbp } = getFacebookCookies();
    
    const payload = {
      event_name: eventName,
      url: window.location.href,
      fbc,
      fbp,
      event_id: generateEventId(),
      ...additionalData,
    };
    
    const response = await fetch(`${API}/api/tracking/facebook`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    
    const result = await response.json();
    
    if (result.success) {
      console.log(`✅ FB Event: ${eventName}`, result.event_id);
    } else {
      console.warn(`⚠️ FB Event failed: ${eventName}`, result.error);
    }
    
    return result;
  } catch (error) {
    console.error(`❌ FB Tracking error: ${eventName}`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Track PageView event
 */
export const trackPageView = () => {
  return trackEvent('PageView');
};

/**
 * Track InitiateCheckout event (when user clicks "Démarrer maintenant")
 */
export const trackInitiateCheckout = (value = 89.0, currency = 'EUR') => {
  return trackEvent('InitiateCheckout', { value, currency });
};

/**
 * Track AddPaymentInfo event (when user enters payment info on Stripe)
 */
export const trackAddPaymentInfo = (value = 89.0, currency = 'EUR', email = null) => {
  return trackEvent('AddPaymentInfo', { value, currency, email });
};

/**
 * Track Purchase event (after successful payment)
 */
export const trackPurchase = (value, currency = 'EUR', transactionId = null, email = null) => {
  return trackEvent('Purchase', { 
    value, 
    currency, 
    transaction_id: transactionId,
    email,
  });
};

export default {
  trackPageView,
  trackInitiateCheckout,
  trackAddPaymentInfo,
  trackPurchase,
};
